import actions from './actions';

const {
  LIST_GASTOS,
  LIST_GASTOS_SELECTBOX,
  CREATE_GASTOS,
  READ_GASTOS,
  UPDATE_GASTOS,    
} = actions;

const initialState = {
  data: [],
  dataSelectBox: [],
  record: {},   
};


const gastosCrudReducer = (state = initialState, action) => {
  const { type, data, err } = action;
  switch (type) {
    case LIST_GASTOS:
      return {
        ...state,
        data: data
      }
    case LIST_GASTOS_SELECTBOX:
      return {
        ...state,
        dataSelectBox: data
      }
    case CREATE_GASTOS:
      return {
        ...state,
        record: data
      }
    case READ_GASTOS:
      return {
        ...state,
        record: data
      }
    case UPDATE_GASTOS:
      return {
        ...state,
        record: data
      }
    default:
      return state;
  }
};


export default gastosCrudReducer;
